<div *ngIf="!userService.isOnlyTg">
    <div *ngIf="badges?.length" class="relative max-md:pb-10">
        <div class="grid grid-cols-2 md:flex-start-stretch gap-y-5 flex-wrap w-full">
            <div *ngFor="let item of badges" class="flex-center-stretch md:w-[143px]">
                <app-badge [badge]="item" [shownType]="pageType"></app-badge>
            </div>
        </div>

        <div
            *ngIf="pageType === 'profile'"
            class="w-fit absolute max-md:bottom-0 max-md:left-1/2 max-md:-translate-x-1/2 max-md:translate-y-2.5 md:top-0 md:right-0 md:-translate-y-[60px]"
        >
            <button nz-button nzSize="small" (click)="showAll()">View All</button>
        </div>
    </div>

    <div *ngIf="!badges?.length" class="w-32 mx-auto text-center text-[#b5b5b5]">
        <img class="mx-auto w-32" src="/assets/imgs/no-data/no-data.png" alt="No Data" />
        <div>No Badges</div>
    </div>
</div>

<div *ngIf="userService.isOnlyTg">
    <!-- TG Connect Wallet -->
    <div class="text-center pb-10 text-[#b5b5b5]">
        <img class="mx-auto w-32" src="/assets/imgs/no-data/no-data.png" alt="No Data" />
        <div>Please connect your wallet first.</div>
        <button nz-button nzType="primary" class="mt-4 !h-[34px] !w-[137px]" nzSize="small" (click)="commonService.showLogInModal('Connect New Wallet')">
            <span class="colorful-text">Connect Wallet</span>
        </button>
    </div>
</div>
